"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoryRouter = exports.browserRouter = exports.routerSwitch = exports.notFoundRouteCase = exports.route = void 0;
var query_string_1 = __importDefault(require("query-string"));
var react_1 = __importDefault(require("react"));
var ReactRouterDom = __importStar(require("react-router-dom"));
var widgets_main_1 = require("../widgets-main");
var options_1 = require("../basics/options");
/**
 * A helper function to create a typed-[[Route]] with no title.
 */
var route = function (path, paramsToRoute) {
    return ({ path: path, paramsToRoute: paramsToRoute });
};
exports.route = route;
/**
 * A helper function to construct a typed [[Route]] which has no path and no parameters.
 * It acts as a **catch-all** (default) router.
 */
var notFoundRouteCase = function (makeRoute) {
    return { paramsToRoute: makeRoute };
};
exports.notFoundRouteCase = notFoundRouteCase;
/**
 * An adapter from an array of routes `R` into a widget `R`
 * Note: There is no support for "nested routing". All hereby supllied routes act at top-level.
 */
function routerSwitch(options) {
    return function (routes) { return (0, widgets_main_1.fromJSX)(function (onDone) {
        return react_1.default.createElement(RouteForwarder, { routes: routes, onDone: onDone, options: options, key: (0, options_1.option)("key", options) });
    }); };
}
exports.routerSwitch = routerSwitch;
/** A `browserRouter` decorates a widget with a `ReactRouterDom.BrowserRouter` top-level component.
 * @param w is a widget, and *normally* this should contain a routerswitch
 */
function browserRouter(options) {
    return function (w) { return (0, widgets_main_1.fromJSX)(function (onDone) {
        return react_1.default.createElement(ReactRouterDom.BrowserRouter, { key: (0, options_1.option)("key", options) }, w.run(onDone));
    }); };
}
exports.browserRouter = browserRouter;
/** A `memoryRouter` decorates a widget with a `ReactRouterDom.memoryRouter` top-level component.
 * This router behaves the same as the browserRouter, but does not change the url of the document.
 * This is useful for none browser environments like React native, electron app or when you simply
 * don't have a real web server
 * @see https://reactrouter.com/web/api/MemoryRouter
 * @param w is a widget, and *normally* this should contain a routerswitch
 */
function memoryRouter(options) {
    return function (w) { return (0, widgets_main_1.fromJSX)(function (onDone) {
        return react_1.default.createElement(ReactRouterDom.MemoryRouter, { key: (0, options_1.option)("key", options) }, w.run(onDone));
    }); };
}
exports.memoryRouter = memoryRouter;
var RouteForwarder = /** @class */ (function (_super) {
    __extends(RouteForwarder, _super);
    function RouteForwarder(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {};
        return _this;
    }
    RouteForwarder.prototype.render = function () {
        var _this = this;
        return react_1.default.createElement(ReactRouterDom.Switch, { key: (0, options_1.option)("key", this.props.options) }, this.props.routes.map(function (currentRoute) {
            return react_1.default.createElement(ReactRouterDom.Route, { key: "route-".concat(currentRoute.path), exact: true, path: currentRoute.path, component: function (currentRouteParams) {
                    var s = _this.state;
                    var nextState = (__assign(__assign({}, s), { currentRoute: currentRoute, currentRouteParams: currentRouteParams, callback: undefined }));
                    if ((_this.state.currentRoute && _this.state.currentRouteParams &&
                        (_this.state.currentRouteParams.location.pathname != currentRouteParams.location.pathname ||
                            _this.state.currentRouteParams.location.search != currentRouteParams.location.search)) ||
                        !_this.state.currentRoute || !_this.state.currentRouteParams) {
                        nextState = __assign(__assign({}, nextState), { callback: function () { return _this.props.onDone(currentRoute.paramsToRoute(__assign(__assign({}, currentRouteParams.match.params), query_string_1.default.parse(currentRouteParams.location.search)))); } });
                    }
                    if (nextState.callback != undefined) {
                        setTimeout(function () {
                            return _this.setState(nextState, function () {
                                if (_this.state.callback) {
                                    var callback_1 = _this.state.callback;
                                    return _this.setState(function (s) { return (__assign(__assign({}, s), { callback: undefined })); }, function () {
                                        if (currentRoute.title != undefined)
                                            document.title = currentRoute.title;
                                        callback_1();
                                    });
                                }
                            });
                        }, 10);
                    }
                    return null;
                } });
        }));
    };
    return RouteForwarder;
}(react_1.default.Component));
